import gsap from "gsap";

let animDuration = 0.5;

if (!!prefersReducedMotion) {
    animDuration = 0;
}

const $html = $('html'),
    intervalTime = 250,
    minWaitTime = 1000,
    maxWaitTime = 5000;

function hideLoader() {
    const $loader = $('.page-loader'),
        $iconBars = $('.page-loader__icon .sprog-icon span'),
        $iconBarTop = $('.page-loader__icon .sprog-icon span:nth-child(1)'),
        $iconBarMiddle = $('.page-loader__icon .sprog-icon span:nth-child(2)');

    const tlIcon = gsap.timeline();

    const tlIconInit = gsap.timeline({
        delay: animDuration
    });

    const tlIconRepeat = gsap.timeline({
        delay: animDuration * 0.25,
        repeat: -1,
        repeatDelay: animDuration * 0.5,
        repeatRefresh: true
    });

    const tlMain = gsap.timeline({
        paused: true,
        onComplete: pageLoaderHidden
    });

    // create main transition animation
    tlMain.to($loader, {
        duration: animDuration * 2,
        width: 0,
        right: '100%',
        ease: 'Expo.easeInOut',
        delay: animDuration,
    })
    .set($loader, {
        right: 0,
    });

    // prepare icon for animation
    gsap.set($iconBars, {
        top: 'auto',
        bottom: 0,
        transform: 'scaleX(0)'
    });

    // create icon animation
    tlIconInit.to($iconBars, {
        duration: animDuration,
        transform: 'scaleX(1)'
    });

    tlIconRepeat.to($iconBarTop, {
        duration: animDuration,
        delay: animDuration * 0.25,
        ease: 'power1.out',
        bottom: 'auto'
    })
    .to($iconBarMiddle, {
        duration: animDuration,
        ease: 'power1.out',
        bottom: '42.5%',
    }, '<')
    .fromTo($iconBarMiddle, {
        rotation: 0
    }, {
        duration: animDuration * 2,
        ease: 'power1.Out',
        rotation: 180,
    }, '<')
    .to($iconBarMiddle, {
        duration: animDuration,
        ease: 'power1.in',
        bottom: 0,
    }, '-='+animDuration)
    .to($iconBarTop, {
        duration: animDuration * 0.875,
        ease: 'power1.in',
        bottom: 0
    }, '<');

    tlIcon.add(tlIconInit).add(tlIconRepeat);

    function pageLoaderHidden() {
        $('body').trigger('pageLoaderHidden');
        tlIcon.pause(0);
    }

    window.addEventListener('load', function() {
        let elapsedTime = 0;

        let timer = setInterval(function () {
            elapsedTime += intervalTime;

            const fontsLoaded = $html.hasClass('wf-active') || $html.hasClass('wf-inactive'); // wait for typekit fonts
            const isTimeUp = elapsedTime >= maxWaitTime;

            if (fontsLoaded || isTimeUp) { // if fonts loaded or max time has elapsed
                if (elapsedTime >= minWaitTime) { // if min time has elapsed
                    clearInterval(timer);
                    tlMain.play();
                }
            }
        }, intervalTime);
    });
}

hideLoader();
